import type { FC } from 'react';

import { DotsController } from './components/DotsController/DotsController';

import styles from './Controller.module.scss';

interface Props {
  currentSlide: number;
  numberOfImages: number;
  numberOfVideos: number;
}

export const Controller: FC<Props> = ({
  currentSlide,
  numberOfImages,
  numberOfVideos,
}) => {
  if (numberOfImages + numberOfVideos < 2) return null;
  return (
    <DotsController
      currentSlide={currentSlide}
      numberOfImages={numberOfImages}
      className={styles.dots}
      numberOfVideos={numberOfVideos}
    />
  );
};

Controller.displayName = 'Controller';
